<template>
  <div id="app" class="dark-mode" :class="{'overflow-x-hidden': this.resultPage.isMobile}">
    <delete-job-modal></delete-job-modal>
    <share-modal></share-modal>
    <unlock-pro-modal></unlock-pro-modal>
    <credit-limit-modal></credit-limit-modal>
    <unlock-pro-modal></unlock-pro-modal>
    <max-concurrent-limit-modal></max-concurrent-limit-modal>
    <generic-error-modal></generic-error-modal>
    <job-failed-modal></job-failed-modal>

    <BaseLayout v-if="resultPage.isMobile === false  && resultPage.isFullRes === true">
      <template v-slot:topbar>
        <router-view name="Topbar"></router-view>
      </template>
      <template v-slot:sidebar-left-stacked>
        <router-view name="SidebarLeftStacked"></router-view>
      </template>
      <template v-slot:sidebar-left>
        <router-view name="SidebarLeft"></router-view>
      </template>
      <template v-slot:main-canvas-ad >
        <div class="d-flex justify-content-center banner-ad-size" v-if="true === false">
          <div :id="adId"></div>
        </div>
      </template>
      <template v-slot:secondary-nav>
        <router-view name="SecondaryNav"></router-view>
      </template>
      <template v-slot:main-canvas>
        <router-view :key="$route.fullPath"></router-view>
      </template>
      <template v-slot:sidebar-bottom>
        <router-view name="SidebarBottom"></router-view>
      </template>
      <template v-slot:sidebar-right>
        <router-view name="SidebarRight"></router-view>
      </template>
    </BaseLayout>

    <MediumLayout v-if="resultPage.isMobile === false && resultPage.isFullRes === false">
      <template v-slot:topbar>
        <router-view name="Topbar"></router-view>
      </template>
      <template v-slot:sidebar-left-stacked>
        <router-view name="SidebarLeftStacked"></router-view>
      </template>
      <template v-slot:sidebar-left-medium>
        <router-view name="SidebarLeftMedium"></router-view>
      </template>
      <template v-slot:main-canvas-ad >
        <div class="d-flex justify-content-center banner-ad-size" v-if="true === false">
          <div :id="adId"></div>
        </div>
      </template>
      <template v-slot:secondary-nav>
        <router-view name="SecondaryNav"></router-view>
      </template>
      <template v-slot:main-canvas>
        <router-view :key="$route.fullPath"></router-view>
      </template>
      <template v-slot:sidebar-right-medium>
        <router-view name="SidebarRightMedium"></router-view>
      </template>
    </MediumLayout>

    <MobileLayout v-if="resultPage.isMobile === true">
      <template v-slot:main-canvas>
        <router-view name="MobileDefault"></router-view>
      </template>
     <!-- <template v-slot:mobile-secondary-navbar>
        <router-view name="MobileSecondaryNavbar"></router-view>
      </template>
      <template v-slot:mobile-navbar>
        <router-view name="MobileNavbar"></router-view>
      </template>-->
    </MobileLayout>
  </div>
</template>
<script>
import store from './mixins/store.mixin'
import JobManager from "./manager/JobManager";
import BaseLayout from "./layout/BaseLayout.vue";
import {EventBus} from "./events/event.bus";
import {EVENT_APP_NAVIGATE} from "./events/app.events";
import MagicEditorManager from "./manager/MagicEditorManager";
import MobileLayout from "./layout/MobileLayout.vue";
import CreditLimitModal from "./components/Modal/CreditLimitModal.vue";
import UnlockProModal from "./components/Modal/UnlockProModal.vue";
import MaxConcurrentLimitModal from "./components/Modal/MaxConcurrentLimitModal.vue";
import GenericErrorModal from "./components/Modal/Error/GenericErrorModal.vue";
import JobFailedModal from "./components/Modal/Error/JobFailedModal.vue";
import DeleteJobModal from "./components/Modal/DeleteJobModal.vue";
import ShareModal from "./components/Modal/ShareModal.vue";
import user from "./mixins/user.mixin";
import currentJob from "./mixins/current_job.mixin";
import {satGlobals} from "../../../../sat/helper/sat-globals";
import MediumLayout from "./layout/MediumLayout.vue";

export default {
  name: "AiMagicEditor",
  components: {
    MediumLayout,
    ShareModal,
    DeleteJobModal,
    JobFailedModal,
    GenericErrorModal,
    MaxConcurrentLimitModal,
    CreditLimitModal,
    UnlockProModal,
    BaseLayout,
    MobileLayout,
  },
  mixins: [
    store,
    user,
      currentJob,
  ],
  data() {
    return {
      event_app_navigate: EVENT_APP_NAVIGATE,
      listener: false,
      adId: satGlobals.getProjectName().toLowerCase() + '_post_1'
    };
  },
  created: function () {
    if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
      this.adId = 'td-top-leaderboard-1';
    }
    if (satGlobals.getProjectName().toLowerCase() === 'online-convert') {
      this.adId = 'post_conversion_728x90';
    }
    let jobId = JobManager.create()

    if (this.listener === false) {
      JobManager.listen();
      MagicEditorManager.watchMobile();
      this.navigationListener();
      this.listener = true;
    }

    MagicEditorManager.updateMobile();
    MagicEditorManager.listen();
    MagicEditorManager.initJob(jobId);
  },
  mounted: function () {
  },
  methods: {
    navigationListener() {
      EventBus.$on(this.event_app_navigate, (route, params, query, replace = false) => {
        if (replace === true) {
          this.$router.replace({path: route, params: params, query: query});
        } else {
          this.$router.push({path: route, params: params, query: query});
        }
      })
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.banner-ad-size {
  min-height: 90px;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
#app {
  height: calc(100% - 65px);
  background: #F5F5F5;


  ::-webkit-scrollbar {
    width: 12px;
  }
  ::-webkit-scrollbar-button {
    width: 8px;
    height:0;
  }
  ::-webkit-scrollbar-track {
    background:#eee;
    border: thin solid lightgray;
    //box-shadow: 0px 0px 3px #dfdfdf inset;
    border-radius:0;
    border-top: 0;
    border-bottom: 0;
  }
  ::-webkit-scrollbar-thumb {
    background: #a8a8a8;
    border: thin solid #999;
    border-radius:0;
  }
  ::-webkit-scrollbar-thumb:hover {
    background:#7d7d7d;
  }
}
</style>
